import { getDataFromPocket } from '../../utils/pocket';
import { injectSprite } from '../../utils/svg';

export async function injectSVGSprite() {
    const meta = getDataFromPocket<string[]>('svg_symbols', false);

    if (!meta?.length) return;

    await injectSprite('svg-sprite-critical', `/dist/svg/?q=${meta.join(',')}`);
}
